import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import Layout from "@/components/Layout";
import { useAuth } from "@/contexts/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name?.split(" ")[0] || ""}`);
      const dest = loc.state?.from?.pathname || (u.role === "admin" ? "/admin" : "/account");
      nav(dest, { replace: true });
    } catch (err) { toast.error(err.message); }
    finally { setBusy(false); }
  }

  return (
    <Layout>
      <div className="max-w-md mx-auto px-6 py-20">
        <div className="overline text-[#C9A227]">Welcome back</div>
        <h1 className="mt-3 text-4xl font-light text-[#163A2F]">Sign in</h1>
        <p className="mt-2 text-[#163A2F]/60 text-sm">Continue your Norbu journey.</p>

        <form onSubmit={submit} className="mt-10 space-y-5">
          <div>
            <label className="overline text-[#163A2F]/70">Email</label>
            <input
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email"
              className="mt-1 w-full px-4 py-3 border hairline bg-transparent focus:outline-none focus:border-[#C9A227]"
            />
          </div>
          <div>
            <label className="overline text-[#163A2F]/70">Password</label>
            <input
              type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password"
              className="mt-1 w-full px-4 py-3 border hairline bg-transparent focus:outline-none focus:border-[#C9A227]"
            />
          </div>
          <button type="submit" disabled={busy}
            data-testid="login-submit"
            className="w-full bg-[#163A2F] text-white py-4 uppercase text-xs tracking-[0.25em] hover:bg-[#0A1C16] transition-colors disabled:opacity-50"
          >
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <p className="mt-6 text-sm text-[#163A2F]/70 text-center">
          New here? <Link to="/register" className="link-gold text-[#163A2F]">Create an account</Link>
        </p>
        <p className="mt-4 text-xs text-[#163A2F]/50 text-center">Admin demo: admin@norbu.com / Admin@123</p>
      </div>
    </Layout>
  );
}
